import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

import isClosedStage from "./isClosedStage";

const isOpenStage = (stage: Stage) => !isClosedStage(stage);

export default isOpenStage;
